	angular.module('jv.Admin.Users')
    .factory('modalObjectTemplateFAC', [function () {
        return {
            get: function(typeObject) {
                return {
                    type: typeObject.name.toUpperCase(),
                    show: true,
                    headText: typeObject.title,
                    showCC: false,
                    showBCC: false,
                    showLinks: false,
                    templates: [],
                    templatePlaceHolder: typeObject.placeholder,
                    subjectPlaceHolder: typeObject.subjectPlaceholder
                };
            },
            setDefault: function(templates) {
                var selectedTemplate = {};
                angular.forEach(templates, function(templt){
                    if(templt['default']){
                        selectedTemplate.template = templt;
                        selectedTemplate.subject = templt.subject;
                        selectedTemplate.body = templt.body;
                    }
                });
                return selectedTemplate;
            }
        };
    }])
    .controller('jvAdminUsersDataSyncEmployeeSettingsController',
        ['$scope', 'adminUserSVC','$rootScope', '$location', '$route', 'breadcrumbsResolve', 'enumToValueMap', 'commonListActionsFAC', '$timeout', 'modalObjectTemplateFAC','Reqs','TemplateLoader',
            function($scope, adminUserSVC, $rootScope, $location, $route, breadcrumbsResolve, enumToValueMap, commonListActionsFAC, $timeout, modalObjectTemplateFAC, Reqs, TemplateLoader) {
	        	$scope.checkbox = {
	        			sendInviteEmail: false,
	        			fullSync:false,
	        			resetSync:false,
	        			considerExclusionList:false
	        			
	        	};
				$scope.uploadedFiles = {
					privateKey:{},
					oldPrivateKeyFileName: "" 
				};
				$scope.privateKeyUploaded = false;
        		$scope.employeeUrl = jvUrls.admin + '/action/user/search?&roleName=HR';
        		$scope.flags.loading = true;
        		$scope.settings = {};
        		$scope.fullSyncFlagWarning = false;
                $scope.initialize = function() {
                	$scope.timesLength = 0;
                	$scope.flags.loading = true;
                	$scope.notifyUsers = [];
                	$scope.notifications = false;
                	$scope.hiringManagerEmails = [];
                	$scope.sendLogFileAsAttachment = false;
            		$scope.hideDisplay = true;
            		$scope.hideEdit = true;
                    $scope.timeZoneSelected = null;
                    $scope.notifications = false;
                    $scope.hiringManagerIds = [];
                    $scope.jobExecutionId = null;
                    $scope.firstHour = null;
                    $scope.secondHour = null;
                    $scope.notifyUsersString = null;
                    $scope.addSyncTime = false;
                }
                
                $scope.initialize();
                
                $scope.timeZone = [ ];
                adminUserSVC.getTimeZones({}, function( results ){
                    $scope.timeZone= results.resultList;
                    angular.forEach($scope.timeZone, function(timezone){
                    	timezone.openSysId = timezone.openSysId.toString();
                    	if(results && results.userTimeZone && results.userTimeZone.ID && timezone.openSysId === results.userTimeZone.ID) {
                    		$scope.timeZoneSelected = {name: timezone.name, openSysId: timezone.openSysId.toString(), systemId: timezone.systemId};
                    	}
                    });
                    //$scope.timeZoneSelected = {name: "(GMT) Coordinated Universal Time", openSysId: "Etc/GMT", systemId: "UTC"};
                });
                
                $scope.breadcrumbsConfig = breadcrumbsResolve;
                $scope.employeeMultipleSelect = Reqs.employeeMultipleSelect;
                $scope.settings.sheduledTime =  $scope.settings.sheduledTime1 = [
                                       {id:"0", text: "12am (00:00)"},
                                       {id:"1", text: " 1am (01:00)"},
                                       {id:"2", text: " 2am (02:00)"},
                                       {id:"3", text: " 3am (03:00)"},
                                       {id:"4", text: " 4am (04:00)"},
                                       {id:"5", text: " 5am (05:00)"},
                                       {id:"6", text: " 6am (06:00)"},
                                       {id:"7", text: " 7am (07:00)"},
                                       {id:"8", text: " 8am (08:00)"},
                                       {id:"9", text: " 9am (09:00)"},
                                       {id:"10", text: " 10am (10:00)"},
                                       {id:"11", text: " 11am (11:00)"},
                                       {id:"12", text: " 12pm (12:00)"},
                                       {id:"13", text: " 1pm (13:00)"},
                                       {id:"14", text: " 2pm (14:00)"},
                                       {id:"15", text: " 3pm (15:00)"},
                                       {id:"16", text: " 4pm (16:00)"},
                                       {id:"17", text: " 5pm (17:00)"},
                                       {id:"18", text: " 6pm (18:00)"},
                                       {id:"19", text: " 7pm (19:00)"},
                                       {id:"20", text: " 8pm (20:00)"},
                                       {id:"21", text: " 9pm (21:00)"},
                                       {id:"22", text: " 10pm (22:00)"},
                                       {id:"23", text: " 11pm (23:00)"}
                                   ];
        		$scope.settings.scheduledTimeSelected = $scope.settings.sheduledTime[0];
        		$scope.settings.scheduledTimeSelected1 = $scope.settings.sheduledTime1[0];
                $scope.settings.delimiters=[
                	 {id:"0", text: ", (Comma)"},
                	 {id:"1", text: "\\t (Tab)"}
                ];
				$scope.templates = TemplateLoader.register({
					replacePrivateKeyModal: '/admin/config/users/replacePrivateKeyModal.html',
					removePrivateKeyModal: '/admin/config/users/removePrivateKeyModal.html'
				});

				$scope.replace = function(){
					if($scope.uploadedFiles && $scope.uploadedFiles.privateKey.file){
						$scope.hideModals();
					} else {
						$scope.fileError = true;
					}

				};

				$scope.cancelReplacePrivateKeyModal = function(){
					$scope.uploadedFiles.privateKey.file = $scope.uploadedFiles.oldPrivateKeyFileName;
					$scope.hideModals();
				}

				$scope.remove = function(){
					$scope.settings.enablePGPSecurity =false;
					$scope.privateKeyUploaded = false;
					$scope.uploadedFiles = {
						privateKey:{} 
					};
					$scope.hideModals();
				};

				 //Used to hide all the modals on the page
				 $scope.hideModals = function(){
					angular.forEach($scope.modals, function(val, key) {
						 $scope.modals[key].show = false;
					});
				};

				$scope.openReplaceKeyModal = function(){
					$rootScope.$broadcast('showReplacePrivateKeyModal', "replace");
				};

				$scope.openRemoveKeyModal = function(){
					$rootScope.$broadcast('showRemovePrivateKeyModal', "remove");
				};
	
				var showReplacePrivateKeyModal = $rootScope.$on('showReplacePrivateKeyModal', function(event, data) {
					$scope.uploadedFiles.oldPrivateKeyFileName = $scope.uploadedFiles.privateKey.file;
					$scope.showModals('replacePrivateKeyModal');
				});

				var showRemovePrivateKeyModal = $rootScope.$on('showRemovePrivateKeyModal', function(event, data) {
					$scope.showModals('removePrivateKeyModal');
				});

				$scope.reset = function(){
					$scope.uploadScreen = false;
					$scope.fileError = false;
				};

				// Modal Information
				$scope.modals = {
					replacePrivateKeyModal: {
						show: false
					},
					removePrivateKeyModal: {
						show: false
					}
				};

				//Used to show the move modal
				$scope.showModals = function(modal){
					$scope.reset();
					TemplateLoader.load(modal).then(function(){
						$scope.modals[modal].show = true;
					});
				};

                $scope.showHideSyncTime = function() {
                	$scope.addSyncTime = !$scope.addSyncTime;
                }
                
                $scope.setNotification = function(response) {
                	angular.forEach($scope.timeZone, function(timezone){
                        if(timezone.openSysId === $scope.zoneId) {
                        	$scope.timeZoneSelected = {name: timezone.name, openSysId: $scope.zoneId, systemId: timezone.systemId};
                        }
                    });
                	if(response && response.resultList[0] && response.resultList[0].notification && response.resultList[0].notification.emailAttachment) {
                    	$scope.sendLogFileAsAttachment = response.resultList[0].notification.emailAttachment;
                	}
                	if(response && response.resultList[0] && response.resultList[0].notification && response.resultList[0].notification.notifyUsers) {
                		$scope.hiringManagerIdsResponse= [];
        				$scope.notifications = true;
        				angular.forEach(response.resultList[0].notification.notifyUsers, function(notifyUser){
        					if(notifyUser.email) {
            					$scope.notifyUsers.push(notifyUser.email);
            				}
        					$scope.hiringManagerIdsResponse.push({"EId":notifyUser.EId,"email":notifyUser.email,"firstName":notifyUser.firstName,"fullName":notifyUser.fullName,"lastName":notifyUser.lastName});
                        });
        				$scope.hiringManagerIds = $scope.hiringManagerIdsResponse;
        			}
        			if($scope.notifyUsers && $scope.notifyUsers.length > 0) {
        				 $scope.notifyUsersString = $scope.notifyUsers.join(", ");
        			}
        			$scope.hideDisplay = true;
        			$scope.hideEdit = false;
                }
                $scope.getSftpLogs = function() {
                	$scope.flags.loading = true;
                	$scope.initialize();
                	adminUserSVC.getSftpLogs({},function(response){
                		if(response && response.resultList && response.resultList.length > 0) {
                			$scope.jobExecutionId = response.resultList[0].id;
                			if(response.resultList[0].schedule && response.resultList[0].schedule.times && response.resultList[0].schedule.times.length > 0) {
                				$scope.timesLength = response.resultList[0].schedule.times.length;
                			}
                			if (response.resultList[0].schedule && response.resultList[0].schedule.times && response.resultList[0].schedule.times.length > 0) {
                				$scope.firstHour = response.resultList[0].schedule.times[0].hour.toString();
                    			$scope.settings.scheduledTimeSelected = $scope.settings.sheduledTime[$scope.firstHour];
                			}
                			if (response.resultList[0].schedule && response.resultList[0].schedule.times && response.resultList[0].schedule.times.length > 1) {
                				$scope.secondHour = response.resultList[0].schedule.times[1].hour.toString();
                    			$scope.settings.scheduledTimeSelected1 = $scope.settings.sheduledTime1[$scope.secondHour];
                    			$scope.addSyncTime = true;
                			}
                			if(response.resultList[0].customData && response.resultList[0].customData.sendInviteEmailToEmployees) {
                				if(response.resultList[0].customData.sendInviteEmailToEmployees === "true") {
                					$scope.checkbox.sendInviteEmail = true;
                				} else {
                					$scope.checkbox.sendInviteEmail = false;
                				}
                			}
                			if(response.resultList[0].customData && response.resultList[0].customData.fullSync) {
                				if(response.resultList[0].customData.fullSync === "true") {
                					$scope.checkbox.fullSync = true;
                				} else {
                					$scope.checkbox.fullSync = false;
                				}
                			}
                			if(response.resultList[0].customData && response.resultList[0].customData.resetSync) {
                				if(response.resultList[0].customData.resetSync === "true") {
                					$scope.checkbox.resetSync = true;
                				} else {
                					$scope.checkbox.resetSync = false;
                				}
                			}
                			if(response.resultList[0].customData && response.resultList[0].customData.considerExclusionList) {
                				if(response.resultList[0].customData.considerExclusionList === "true") {
                					$scope.checkbox.considerExclusionList = true;
                				} else {
                					$scope.checkbox.considerExclusionList = false;
                				}
                			}
                			if(response.resultList[0].customData && response.resultList[0].customData.enablePGPSecurity === "true"){
									$scope.settings.enablePGPSecurity = true;
									$scope.privateKeyUploaded = true;
									$scope.uploadedFiles.privateKey.file = response.resultList[0].customData.privateKeyFileName;
                			} else {
								$scope.settings.enablePGPSecurity = false;
							}
							
                			$scope.zoneId = response.resultList[0].schedule.zoneId;
                			if($scope.timeZone && $scope.timeZone.length === 0) {
                				$scope.getResponse = response;
                				adminUserSVC.getTimeZones({}, function( results ){
                                    $scope.timeZone= results.resultList;
                                    $scope.setNotification($scope.getResponse);
                                });
                				
                			} else {
                				$scope.setNotification(response);
                			}
                     	   if(response.resultList[0].connector.parameters && response.resultList[0].connector.parameters.delimiter!==undefined){
                    		   $scope.settings.delimiterSelected=response.resultList[0].connector.parameters.delimiter===","?$scope.settings.delimiters[0]:$scope.settings.delimiters[1];
                    	   } else{
                    		   $scope.settings.delimiterSelected=$scope.settings.delimiters[0];
                    	   }
                		} else {
                			$scope.hideDisplay = false;
                			$scope.hideEdit = true;
                		}
                		$scope.flags.loading = false;
                	});
                }
                
                $scope.getSftpLogs();
                
                $scope.editSyncSettings = function() {
                	$scope.hideDisplay = false;
                	$scope.hideEdit = true;
                }
                
                $scope.cancelSyncSettings = function() {
                	if($scope.jobExecutionId !== null) {
                		$scope.hideDisplay = true;
                    	$scope.hideEdit = false;
                	}
                }
                
                $scope.saveSyncSettings = function() {
                	var args = {};
                	if($scope.settings.scheduledTimeSelected && $scope.settings.scheduledTimeSelected.id !== "") {
                		args.firstHour = parseInt($scope.settings.scheduledTimeSelected["id"]);
                	}
                	if($scope.settings.scheduledTimeSelected1 && $scope.addSyncTime && $scope.settings.scheduledTimeSelected1.id !== "" ) {
                		args.secondHour = $scope.settings.scheduledTimeSelected1["id"];
                	}
                	if($scope.timeZoneSelected) {
                    	args.timezoneId = $scope.timeZoneSelected.openSysId;
                	}
                    if($scope.settings.delimiterSelected && $scope.settings.delimiterSelected.id !==""){
                    	args.fileDelimiter = $scope.settings.delimiterSelected.id==="1"?'\\t':',';
                    } else{
                    	args.fileDelimiter = ',';
                    }
                	if (args.firstHour !== undefined || args.secondHour !== undefined) {
                	 	angular.forEach($scope.hiringManagerIds, function(hiringManagerId){
                            if(hiringManagerId && hiringManagerId.email){
                            	$scope.hiringManagerEmails.push(hiringManagerId.email);
                            }
                        });
                    	if($scope.hiringManagerEmails && $scope.hiringManagerEmails.length > 0) {
                    		args.hiringManagerEmails = $scope.hiringManagerEmails.join(",");
                    	}
                    	args.sendFileAsAttachment = $scope.sendLogFileAsAttachment;
                    	args.sendInviteEmail = $scope.checkbox.sendInviteEmail;
                    	args.fullSync=$scope.checkbox.fullSync;
						args.resetSync=$scope.checkbox.resetSync;
						args.enablePGPSecurity=$scope.settings.enablePGPSecurity;
						args.privateKey=$scope.uploadedFiles.privateKey.file;
						args.hasFileChanged=$scope.uploadedFiles.privateKey.hasFileChanged;
                    	args.considerExclusionList=$scope.checkbox.considerExclusionList;
                    	adminUserSVC.sftpImport(args,function(response){
                			$scope.flags.loading = true;
                			$scope.getSftpLogs();
                    	});
                	}
                	
                }
             $scope.updateResetFlag=function(){
        	   if(!$scope.checkbox.fullSync){
        		   $scope.checkbox.resetSync=false;
        		   $scope.checkbox.considerExclusionList=false;
        		   $scope.fullSyncFlagWarning = false;
        	   } else{
         		  $scope.checkbox.considerExclusionList=true;
         		  $scope.fullSyncFlagWarning = true;
         	   }
              }
        	}
    ]);
